// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media only screen and (min-width: 2560px) {
  .featured_fact_check_thumbnail_overlay_content {
    height: 240px;
    width: 62% !important;
  }
  .featured_fact_check_image_component_title {
    font-size: 30px;
  }
  .featured_fact_check_view_count {
    font-size: 25px;
  }
  .featured_fact_check_thumbnail_overlay_name_and_date {
    font-size: 25px !important;
  }
  .featured_fact_check_button {
    font-size: 20px;
  }
  .featured_story_fact_check_title {
    font-size: 34px;
  }
  .featured_story_fact_check_sub_title {
    font-size: 26px;
  }
  .featured_story_fact_check {
    font-size: 48px;
  }
  .featured_fact_check_image_component {
    width: 60% !important;
    position: relative;
  }
  .featured_story_fact_check_container_mobile_view {
    display: none;
  }
  .fact_check_trending_stories_container {
    padding: 0px 60px 80px 60px !important;
  }
  .fact_check_trending_stories_title_container {
    height: 150px;
  }
  .fact_check_trending_stories_title {
    font-size: 40px;
  }
  .fact_check_trending_container {
    border-radius: 10px;
  }
  .fact_trending_details_container {
    height: 110px;
    width: 100%;
    bottom: 0px !important;
  }

  .featured_fact_check_title {
    width: 90%;
  }


  .join_us_today_text {
    font-size: 35px;
  }
  .join_us_feature_text {
    font-size: 40px;
  }
  .join_us_button {
    font-size: 30px;
    height: 65px;
    border-radius: 15px;
  }

  .fact_check_first_column_card_container {
    height: calc((850 / 2560) * 100vw) !important;
  }
  .fact_check_party_wise_second_column_container {
    gap: 75px !important;
  }
  .fact_check_party_tags_in_mobile {
    display: none;
  }
  .featured_story_image_skeleton {
    height: 800px !important;
  }
  .featured_story_content_skeleton {
    width: 40% !important;
  }
  .fact_check_party_container {
    display: grid;
  }
  .fact_category_wise_card_container {
    height: 300px;
    width: 30%;
  }
  .fact_category_wise_card_title_text {
    font-size: 15px;
  }
  .fact_category_wise_card_author_container {
    height: 35px;
  }
  .join_us_feature_text_ta {
    font-size: 33px;
  }
  .amount_card_content,
  .amount_selected {
    font-size: 25px;
    width: 130px;
    display: flex;
    justify-content: center;
    align-items: center !important;
  }
  .donation_third_row_container_ta > h5 {
    font-size: 30px;
  }
  .amount_input {
    flex-direction: column;
    justify-content: center;
    font-size: 20px;
  }
  .donation_third_row_container_ta {
    gap: 20px;
  }
  .half_circle_container {
    height: 900px !important;
    max-height: 900px !important;
  }
  .social_media_logo {
    width: 70px;
  }
  .social_media_first_content {
    font-size: 23px;
  }
  .social_media_second_content {
    font-size: 28px;
  }
  .fact_category_wise_card_title_text{
    font-size: 23px;
  }
  .fact_category_wise_card_author_name_text{
    font-size: 18px;
  }
  .continue_reading_text{
    font-size: 25px;
  }

}
`, "",{"version":3,"sources":["webpack://./src/styles/screen_2560_layout/screen_2560_fact_check.css"],"names":[],"mappings":"AAAA;EACE;IACE,aAAa;IACb,qBAAqB;EACvB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,qBAAqB;IACrB,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;EACA;IACE,sCAAsC;EACxC;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,UAAU;EACZ;;;EAGA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,6CAA6C;EAC/C;EACA;IACE,oBAAoB;EACtB;EACA;IACE,aAAa;EACf;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,qBAAqB;EACvB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;IACb,UAAU;EACZ;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;;IAEE,eAAe;IACf,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,8BAA8B;EAChC;EACA;IACE,eAAe;EACjB;EACA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,eAAe;EACjB;EACA;IACE,SAAS;EACX;EACA;IACE,wBAAwB;IACxB,4BAA4B;EAC9B;EACA;IACE,WAAW;EACb;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;;AAEF","sourcesContent":["@media only screen and (min-width: 2560px) {\n  .featured_fact_check_thumbnail_overlay_content {\n    height: 240px;\n    width: 62% !important;\n  }\n  .featured_fact_check_image_component_title {\n    font-size: 30px;\n  }\n  .featured_fact_check_view_count {\n    font-size: 25px;\n  }\n  .featured_fact_check_thumbnail_overlay_name_and_date {\n    font-size: 25px !important;\n  }\n  .featured_fact_check_button {\n    font-size: 20px;\n  }\n  .featured_story_fact_check_title {\n    font-size: 34px;\n  }\n  .featured_story_fact_check_sub_title {\n    font-size: 26px;\n  }\n  .featured_story_fact_check {\n    font-size: 48px;\n  }\n  .featured_fact_check_image_component {\n    width: 60% !important;\n    position: relative;\n  }\n  .featured_story_fact_check_container_mobile_view {\n    display: none;\n  }\n  .fact_check_trending_stories_container {\n    padding: 0px 60px 80px 60px !important;\n  }\n  .fact_check_trending_stories_title_container {\n    height: 150px;\n  }\n  .fact_check_trending_stories_title {\n    font-size: 40px;\n  }\n  .fact_check_trending_container {\n    border-radius: 10px;\n  }\n  .fact_trending_details_container {\n    height: 110px;\n    width: 100%;\n    bottom: 0px !important;\n  }\n\n  .featured_fact_check_title {\n    width: 90%;\n  }\n\n\n  .join_us_today_text {\n    font-size: 35px;\n  }\n  .join_us_feature_text {\n    font-size: 40px;\n  }\n  .join_us_button {\n    font-size: 30px;\n    height: 65px;\n    border-radius: 15px;\n  }\n\n  .fact_check_first_column_card_container {\n    height: calc((850 / 2560) * 100vw) !important;\n  }\n  .fact_check_party_wise_second_column_container {\n    gap: 75px !important;\n  }\n  .fact_check_party_tags_in_mobile {\n    display: none;\n  }\n  .featured_story_image_skeleton {\n    height: 800px !important;\n  }\n  .featured_story_content_skeleton {\n    width: 40% !important;\n  }\n  .fact_check_party_container {\n    display: grid;\n  }\n  .fact_category_wise_card_container {\n    height: 300px;\n    width: 30%;\n  }\n  .fact_category_wise_card_title_text {\n    font-size: 15px;\n  }\n  .fact_category_wise_card_author_container {\n    height: 35px;\n  }\n  .join_us_feature_text_ta {\n    font-size: 33px;\n  }\n  .amount_card_content,\n  .amount_selected {\n    font-size: 25px;\n    width: 130px;\n    display: flex;\n    justify-content: center;\n    align-items: center !important;\n  }\n  .donation_third_row_container_ta > h5 {\n    font-size: 30px;\n  }\n  .amount_input {\n    flex-direction: column;\n    justify-content: center;\n    font-size: 20px;\n  }\n  .donation_third_row_container_ta {\n    gap: 20px;\n  }\n  .half_circle_container {\n    height: 900px !important;\n    max-height: 900px !important;\n  }\n  .social_media_logo {\n    width: 70px;\n  }\n  .social_media_first_content {\n    font-size: 23px;\n  }\n  .social_media_second_content {\n    font-size: 28px;\n  }\n  .fact_category_wise_card_title_text{\n    font-size: 23px;\n  }\n  .fact_category_wise_card_author_name_text{\n    font-size: 18px;\n  }\n  .continue_reading_text{\n    font-size: 25px;\n  }\n\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
